exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".align-end-horizontally {\n  display: flex;\n  display: -ms-flexbox;\n  justify-content: flex-end; }\n\ntd.bordered-cell {\n  border: 1px solid #cecece !important; }\n\ntd.borderless-cell {\n  border: 0px !important; }\n\n.dark-background {\n  background: #eee; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/coin_pull_report/print_route_coin/coin_pull_report_print.scss
// module id = 1028
// module chunks = 1